(() => {
  const initialized = new WeakSet();

  const initialize = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);

    const form = root.querySelector('[data-mp-solarbank-max-form]');
    const submit = form?.querySelector('[data-mp-solarbank-max-submit]');
    const submitLabel = submit?.querySelector('[data-mp-solarbank-max-submit-label]');

    form?.addEventListener('submit', () => {
      if (!form.checkValidity() || !submit || !submitLabel) return;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      const loadingLabel = submit.dataset.loadingLabel || 'Wird gesendet …';
      submit.setAttribute('aria-label', loadingLabel);
      submitLabel.textContent = loadingLabel;
      submitLabel.removeAttribute('aria-hidden');
    });

    root.querySelector('[data-mp-solarbank-max-status]')?.focus();

    root.querySelectorAll('.mp-solarbank-max__accordion details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('.mp-solarbank-max__accordion details').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-mp-solarbank-max]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
